var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTagFolderIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.38063 2.33262L5.3805 2.33269L5.38737 2.34453C5.45498 2.46095 5.58607 2.67911 5.8544 2.79396C6.04857 2.87707 6.26517 2.87578 6.3782 2.87511C6.38747 2.87505 6.39604 2.875 6.40385 2.875H10.505C10.9824 2.875 11.375 3.26955 11.375 3.74655V9.75345C11.375 10.2325 10.9839 10.625 10.4949 10.625H1.50513C1.01997 10.625 0.625 10.2281 0.625 9.74815V2.25186C0.625 1.76521 1.01263 1.375 1.50387 1.375H3.98077C4.40246 1.375 4.63448 1.45159 4.79236 1.55382C4.95659 1.66017 5.11432 1.84152 5.30237 2.19074L5.30234 2.19075L5.30546 2.1964L5.38063 2.33262Z",
    stroke: "currentColor",
    strokeWidth: 1.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagFolderIcon);
export default __webpack_public_path__ + "static/media/tag-folder-icon.221479f9e8474ec06510f7ef57b3f336.svg";
export { ForwardRef as ReactComponent };